import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    brands: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '1em',
      '&.card-brands': {
        padding: '0 0 30px 0',
      },
      '&.store-brands': {
        padding: '25px 0',
      },
      '& .brand': {
        marginTop: 20,
        marginRight: 20,
        '&:last-child': {
          marginRight: 0,
        },
        '&.visa': {
          height: 20,
        },
        '&.mastercard': {
          height: 35,
        },
        '&.amex': {
          height: 25,
        },
        '&.extra': {
          height: 25,
        },
        '&.sams-club': {
          height: 35,
        },
        '&.comercial-mexicana': {
          height: 25,
        },
        '&.seven': {
          height: 25,
        },
        '&.walmart': {
          height: 25,
        },
      },
    },
  }),
);

export default useStyles;
